import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

import { maxTextWidth } from '../../constants';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  maxWidth: maxTextWidth,
  gap: theme.spacing(2),
  alignItems: 'center',
  flexDirection: 'column',
  flexWrap: 'wrap',
  justifyContent: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    gap: theme.spacing(4),
  },
}));

export const LanguageName = styled('span', {
  shouldForwardProp: shouldForwardProp(),
})<{ isActive: boolean }>(({ theme, isActive }) => ({
  ...(isActive
    ? {
        fontWeight: theme.typography.fontWeightBold,
      }
    : {
        textDecoration: 'underline',
        cursor: 'pointer',
      }),
}));
